import React from 'react';

import '../style.css';
import CONF from '../Conf';

export default function MessageCard({ language, body, backgroundColor, fontColor, abTest }) {
  const bgColor = CONF.color(backgroundColor);
  const fColor = CONF.color(fontColor);
  return (
    <article className='Message Card' language={language} id={abTest} style={{ backgroundColor: bgColor }}>
      <section style={{ color: fColor }}>
        <p>{body}</p>
      </section>
    </article>
  );
}
